module.exports = __webpack_public_path__ + "img/7.6a07aa37.jpg";